import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ResizedEvent } from 'angular-resize-event';
import { StudyReportEdit } from '../../../model/study-report-edit';
import { StudyReportWizardService, IStudyReportWizard } from '../../../services/wizard/study-report/study-report.wizard.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { CashDeskManualSearchItem } from '../../../model/cash-desk-manual-search-item';
import { InvoiceManualCashDeskService } from '../../../services/invoice-cash-desk/invoice-manual-cash-desk.service';
import { InvoiceCashDeskService } from '../../../services/invoice-cash-desk/invoice-cash-desk.service';
import { PdfService } from '../../../services/pdf.service';

@Component({
  selector: 'cash-desk-manual-association-view-dialog',
  templateUrl: 'cash-desk-manual-association-view-dialog.component.html',
  styleUrls: ['./cash-desk-manual-association-view-dialog.component.css'],
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoiceManualCashDeskService }]
})
export class CashDeskManualAssociationViewDialogComponent implements OnInit {

  safeResourceUrl: SafeResourceUrl;
  canConfirm: boolean;
  loading: boolean;
  widthExp = 800;
  heightExp = 800;

  constructor(public dialogRef: MatDialogRef<CashDeskManualAssociationViewDialogComponent>
    , private notificationToastService: NotificationToastService
    , private invoiceCashDeskService: InvoiceCashDeskService
    , private pdfService: PdfService
    , @Inject(MAT_DIALOG_DATA) public data: CashDeskManualSearchItem) {

  }

  async ngOnInit() {
    try {
      this.loading = true;
      const invoiceCashDesk = await this.invoiceCashDeskService.getInvoiceCashDeskPdf(this.data.Id);
      const pdfUrl = this.pdfService.base64ToPdfUrl(invoiceCashDesk.ReportBase64);
      this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cobranza');
    } finally {
      this.loading = false;
    }
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  acceptClick(): void {
    this.dialogRef.close(true);
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
    this.heightExp = event.newHeight;
  }

}
